import React from 'react';

interface Props {
  text: string;
  type: string;
}

const getStatusClassName = (type: string) => type.toLowerCase().replace(/_/g, '-');

const MissionType: React.FC<Props> = ({ text, type }) => (
  <div className={`badge-base mission-type mission-type--${getStatusClassName(type)}`}>
    <div className="badge-text">
      <span>{text}</span>
    </div>
  </div>
);

export default MissionType;
